import store from "../../vuex/store";

function obterIpCliente() {
    return fetch("https://api.ipify.org?format=json")
        .then((response) => response.json())
        .then((data) => {
            return data.ip;
        })
        .catch((error) => {
            console.error("Erro ao obter o IP:", error);
        });
}

export default class ProcessadorValorAutomatico {
    processar(campo) {
        const valor = campo?.valor;
        const identidadeEfetiva = store.getters["autenticacao/identidadeEfetiva"];

        switch (valor?.chave) {
            case "email":
                return identidadeEfetiva.email || valor?.padrao;
            case "cpf":
                return identidadeEfetiva.cpf || valor?.padrao;
            case "nome":
                return identidadeEfetiva.nome || valor?.padrao;
            case "matricula":
                return identidadeEfetiva.matricula || valor?.padrao;
            case "ip":
                return obterIpCliente().catch(() => {
                    return valor?.padrao;
                });
            default:
                return valor?.padrao;
        }
    }
}
